import { Component, OnInit, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pm-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.css']
})
@Injectable()
export class UploadModalComponent implements OnInit {
  @Input() modalText: string; // Defines the title of the modal
  @Input() modcontent: string; // Defines the content of the modal
  @Input() disablebtn: boolean;
  @Input() reportTile: boolean;
  // Defines the enable/disable of the button
  @Input() removeBtn: boolean;
  @Output('cancelModal') cancelModal = new EventEmitter<any>(); // Emits the cancel event of the modal
  @Output() deleteModal = new EventEmitter<any>(); // Emits the delete event of the modal
  @Input() localDriverBtn: boolean;
  @Input() public widthProgressValue: any;
  public widthProgress: any = 0;
  dialog: any;
  constructor(public activeModal: NgbActiveModal) {
  }
  ngOnInit() {
   setTimeout(() => this.changeWidth(), 100);
  }
  public changeWidth(): any {
    this.widthProgress = this.widthProgress + 15;
    if (this.widthProgress > 95 ) {
      this.widthProgress = 95;
    }
   return this.widthProgress;
}

  cancelAddEditModal() {
    this.cancelModal.emit({});
    this.activeModal.close();

  }

  public delete() {
    this.deleteModal.emit({});
    this.activeModal.close();

  }

}
